import React from "react";
import { useState, useRef } from "react";
import * as Constants from "../Constants?v=0.0.2";

function PasswordTextField(props) {
  const passwordTF = useRef(null);
  const [showPassword, setShowPassword] = useState(false);

  const showHidePasswordHandler = (event) => {
    passwordTF.current.focus();
    setShowPassword((prevState) => {
      return !prevState;
    });
  };

  const passwordValidator = (event) => {
    let flag = Constants.validatePassword(event.target.value);
    props.changeFlag(flag);
    props.onValid(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (props.hasHandleKeyDown) {
      if (event.keyCode === 13) {
        props.onNext();
      }
    }
  };

  return (
    <div className={`ui input icon ${props.className}`}>
      <input
        ref={passwordTF}
        type={showPassword ? "text" : "password"}
        onChange={passwordValidator}
        onBlur={() => {
          props.onBlur();
        }}
        placeholder="Password"
        value={props.value}
        autoComplete={props.isSignUp ? "one-time-code" : "password"}
        onKeyDown={handleKeyDown}
        style={{ paddingRight: "2.67142857rem!important" }}
      />
      {!showPassword && (
        <svg
          onClick={showHidePasswordHandler}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.7606 14.3668C9.1856 13.7928 8.8356 13.0128 8.8356 12.1378C8.8356 10.3848 10.2476 8.9718 11.9996 8.9718C12.8666 8.9718 13.6646 9.3228 14.2296 9.8968"
            stroke="#00000091"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="password-icon"
          />
          <path
            d="M15.1048 12.6989C14.8728 13.9889 13.8568 15.0069 12.5678 15.2409"
            stroke="#00000091"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="password-icon"
          />
          <path
            d="M6.6546 17.4723C5.0676 16.2263 3.7236 14.4063 2.7496 12.1373C3.7336 9.85829 5.0866 8.02829 6.6836 6.77229C8.2706 5.51629 10.1016 4.83429 11.9996 4.83429C13.9086 4.83429 15.7386 5.52629 17.3356 6.79129"
            stroke="#00000091"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="password-icon"
          />
          <path
            d="M19.4476 8.99078C20.1356 9.90478 20.7406 10.9598 21.2496 12.1368C19.2826 16.6938 15.8066 19.4388 11.9996 19.4388C11.1366 19.4388 10.2856 19.2988 9.46759 19.0258"
            stroke="#00000091"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="password-icon"
          />
          <path
            d="M19.887 4.24957L4.11301 20.0236"
            stroke="#00000091"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="password-icon"
          />
        </svg>
      )}
      {showPassword && (
        <svg
          onClick={showHidePasswordHandler}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="password-icon"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.1615 12.0531C15.1615 13.7991 13.7455 15.2141 11.9995 15.2141C10.2535 15.2141 8.8385 13.7991 8.8385 12.0531C8.8385 10.3061 10.2535 8.89108 11.9995 8.89108C13.7455 8.89108 15.1615 10.3061 15.1615 12.0531Z"
            stroke="#00000091"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            className="password-icon"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.998 19.3549C15.806 19.3549 19.289 16.6169 21.25 12.0529C19.289 7.48889 15.806 4.75089 11.998 4.75089H12.002C8.194 4.75089 4.711 7.48889 2.75 12.0529C4.711 16.6169 8.194 19.3549 12.002 19.3549H11.998Z"
            stroke="#00000091"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </div>
  );
}

export default PasswordTextField;
